import { createFileRoute } from '@tanstack/react-router'

import { ReadOnlyScope } from '@/components/base'
import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { planningListFilters } from '@/components/Internal/Planning/planning-list-filters'
import { PlanningView } from '@/components/Internal/Planning/PlanningView'
import { useProjectDetail } from '@/components/Internal/Projects/project-detail-context'

export const Route = createFileRoute('/internal/projects/$id/planning')({
  validateSearch: listSearchValidator(planningListFilters),
  component: ProjectPlanningScreen,
})

function ProjectPlanningScreen() {
  // What a project is planned to cost is the project itself, so the rule is
  // the one that decides about the project.
  const { project, canChange } = useProjectDetail()
  const filters = useListFilters(planningListFilters, Route)
  return (
    <ReadOnlyScope readOnly={!canChange}>
      <PlanningView
        propertyId={project.property.id}
        projectId={project.id}
        filters={filters}
      />
    </ReadOnlyScope>
  )
}
